import { useMutation } from "@tanstack/react-query";
import { VitalSigns } from "@binah/web-sdk";
import {
  submitFaceScanData,
  HealthCheckQuestionnaireData,
  Screenshot,
} from "@/services/core-api-adapter";

interface SubmitFaceScanDataParams {
  healthCheckQuestionnaireData: HealthCheckQuestionnaireData | null;
  quoteId: string | null;
  vitalSigns: VitalSigns | null;
  images: Screenshot[];
}

export function useSubmitFaceScanData() {
  return useMutation({
    mutationFn: (data: SubmitFaceScanDataParams) => submitFaceScanData(data),
  });
}
